import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import StylePopup from '../stylePopup/stylePopup';
import SpeedPopup from '../speedPopup/speedPopup';
@Component({
  components: {
    StylePopup,
    SpeedPopup
  },
})
export default class SpeakerInfo extends Vue {
  @Prop() currSpeaker: any
  @Prop() speakerEmotionCacheVOList: any
  @Prop() querySpeakerInfo: any
  @Prop() theme: string
  @Prop({ default: 'textToVideo' }) source: string // 区分来源：textToVideo / createDrawer
  arrowRightIcon = require('/public/images/migu/arrow_right_icon.png')
  showStylePopup = false
  showSpeedPopup = false
  
  moodName = '默认'
  currSpeed = '1.0'
  @Watch('querySpeakerInfo',  {deep: true, immediate: true})
  listenQuerySpeakerInfo(val) {
    this.moodName = val.speakerStyle
    this.currSpeed = val.speechSpeed
  }
  @Watch('currSpeaker.name')
  listenSpeakerName(oldName, newName) {
    console.log('listenSpeakerName', newName)
    if (newName && newName !== oldName) {
      this.moodName = '默认'
      this.currSpeed = '1.0'
    }
  }
  useSpeaker() {
    const info = {
      speakerName: this.currSpeaker.name,
      speakerStyle: this.moodName,
      speechSpeed: this.currSpeed,
    }
    // 根据 source 区分读写 key：textToVideo 用原 key，createDrawer 用独立 key
    const storageKey = this.source === 'createDrawer' ? 'createDrawerMiguData' : 'textToVideoMiguData';
    const data = localStorage.getItem(storageKey);
    if (data) {
      const { text, styleCode } = JSON.parse(data);
      info['text'] = text || '';
      info['styleCode'] = styleCode || '';
    }
    localStorage.setItem(storageKey, JSON.stringify(info))
    // createDrawer 来源：设置重开标记，来源页（works/audioCreating）返回后恢复抽屉
    if (this.source === 'createDrawer') {
      localStorage.setItem('createDrawerReopen', 'true');
    }
    this.$router.go(-1)
  }
  confirmStyle(moodName) {
    this.moodName = moodName
    this.showStylePopup = false
  }
  confirmSpeed(speed) {
    this.currSpeed = speed
    this.showSpeedPopup = false
  }
}